import React from 'react';
import { Navigate } from 'react-router-dom';
import { PageError, superUsers } from 'components';
import { allRoles } from 'components/generic/ProtectedContent';

// NOTE: These are imported separately to avoid warnings during testing.
import { Welcome } from 'pages/Welcome';
import { HowItWorks } from 'pages/HowItWorks';
import { MyFiles } from 'pages/MyFiles';
import { PurchasedModels } from 'pages/PurchasedModels';
import { Store } from 'pages/Store';
import { ModelCanvas } from 'pages/ModelCanvas';
import { Creators } from 'pages/Creators';
import { Roadmap } from 'pages/Roadmap';
import { Docs } from 'pages/Documentation';
import { PreviewModel } from 'pages/PreviewModel';

import NoAccessText from './NoAccessText';
import { Jobs } from 'pages/Jobs';
import { TeamModels } from 'pages/TeamModels';
import { TeamAdmin } from 'pages/TeamAdmin';
import { ArchVisionAdminDashboard } from 'pages/ArchVisionAdminDashboard';
import { ImageCanvas } from 'pages/ImageCanvas';

const routes = [
  {
    path: '*',
    element: <PageError
      title='404: Not Found'
      text='The page you are looking for does not exist.'
    />,
  },
  {
    path: '/no-access',
    element: <PageError
      type='info'
      title="Insufficient privileges."
      text={<NoAccessText />}
    />,
  },
  {
    path: '/',
    element: <Navigate replace to='/welcome' />,
    authenticate: false,
    allowedRoles: allRoles,
  },
  {
    path: '/welcome',
    element: <Welcome />,
    authenticate: false,
    allowedRoles: allRoles,
  },
  {
    path: '/how-it-works',
    element: <HowItWorks />,
    authenticate: false,
    allowedRoles: allRoles,
  },
  {
    path: '/preview-model',
    element: <PreviewModel />,
    authenticate: false,
    allowedRoles: allRoles,
  },
  {
    path: '/my-files',
    element: <MyFiles />,
    authenticate: true,
    allowedRoles: allRoles,
  },
  {
    path: '/preview',
    element: <PreviewModel />,
    authenticate: true,
    allowedRoles: allRoles,
  },
  {
    path: '/purchased-models',
    element: <PurchasedModels />,
    authenticate: true,
    allowedRoles: allRoles,
  },
  {
    path: '/jobs',
    element: <Jobs />,
    authenticate: true,
    allowedRoles: allRoles,
  },
  {
    path: '/store',
    element: <Store />,
    authenticate: true,
    allowedRoles: allRoles,
  },
  {
    path: '/models',
    element: <Navigate to='/' />,
    authenticate: true,
    allowedRoles: allRoles,
  },
  {
    path: '/creators',
    element: <Creators />,
    authenticate: false,
    allowedRoles: allRoles,
  },
  {
    path: '/creator-models',
    element: <Navigate to='/' />,
    authenticate: true,
    allowedRoles: allRoles,
  },
  {
    path: '/create',
    element: <ModelCanvas />,
    authenticate: true,
    allowedRoles: allRoles,
  },
  {
    path: '/image-canvas',
    element: <ImageCanvas />,
    authenticate: true,
    allowedRoles: allRoles,
  },
  {
    path: '/models/:modelId',
    exact: true,
    element: <ModelCanvas />,
    authenticate: true,
    allowedRoles: allRoles,
  },
  {
    path: '/creator-models/:modelId',
    exact: true,
    element: <ModelCanvas />,
    authenticate: true,
    allowedRoles: allRoles,
  },
  {
    path: '/team-models/:modelId',
    exact: true,
    element: <ModelCanvas />,
    authenticate: true,
    allowedRoles: allRoles,
  },
  {
    path: '/roadmap',
    element: <Roadmap />,
  },
  {
    path: '/documentation',
    element: <Docs />,
    authenticate: false,
    allowedRoles: allRoles,
  },
  {
    path: '/documentation/:id',
    element: <Docs />,
    authenticate: false,
    allowedRoles: allRoles,
  },
  {
    path: '/team-models',
    element: <TeamModels />,
    authenticate: true,
    allowedRoles: allRoles,
  },
  {
    path: '/team-admin',
      element: <TeamAdmin />,
      authenticate: true,
      allowedRoles: allRoles,
  },
  {
    path: '/team-admin/:id',
    element: <TeamAdmin />,
    authenticate: true,
    allowedRoles: allRoles,
  },
  {
    path: '/archvision-admin',
    element: <ArchVisionAdminDashboard />,
    authenticate: true,
    allowedRoles: superUsers,
  },
  {
    path: '/archvision-admin/:id',
    element: <ArchVisionAdminDashboard />,
    authenticate: true,
    allowedRoles: superUsers,
  },
];

export default routes;
